import React, { Component } from "react";
import { PnkConnect } from '../../pnk-react/pnk-miniredux';
import '../../assets/styling/style.css';
import ForgotPage from "./forgot";
import { ForgotPassword } from "../../models/users";
import AppUtils from '../../apputils';
import $ from 'jquery';
import ResetModal from "./resetModal";

class forgotPasswordContainer extends Component {
    constructor() {
        super()
        this.state = {
            txtUserForgetEmail: '',
            txtForgotPasswordValidationMessage: '',
            forgetPassword: false,
            isModalOpen: false
        }

        this.forgetpassworddata = {}

    }
    HandleRouting = (route) => {
        AppUtils.HandlePageClick(this.props.componentprops, route)
    }
    HideResetModal = () => {
        this.setState({
            isModalOpen: false
        })
    }
    CheckForget = (e) => {

        if (e.keyCode === 13) {
            this.ForgotPassword();
        }

    }

    HandleForgotPasswordInputs = (e) => {
        const val = e.target.value;
        const name = e.target.name;
        this.setState({ [name]: val });
        if (name === "txtUserForgetEmail") this.txtUserForgetEmail = val;
    }

    ResetPassword = () => {
        //  alert('www')
        this.ForgotPassword();
    }

    ForgotPassword = () => {
        const emailExpn = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        // alert(this.state.txtUserForgetEmail)
        if (this.state.txtUserForgetEmail === '' || emailExpn.test(this.state.txtUserForgetEmail) !== true) {
            this.setState({
                txtForgotPasswordValidationMessage: 'Enter Valid Email'
            })
            return false

        }

        else {
            // alert('work')
            this.setState({
                txtForgotPasswordValidationMessage: ''
            })
        }
        if (this.state.txtForgotPasswordValidationMessage === '') {
           // alert('eeee' + this.state.forgetPassword)
            this.forgetpassworddata = {
                txtUserForgetEmail: this.state.txtUserForgetEmail,
            }

            this.setState({ forgetPassword: true })
            console.log(this.forgetpassworddata);
        }
    }

    HandleForgetPasswordDataSuccessResponse = (res) => {
        console.log(res);
        if (res !== false) {
            // document.getElementById('spnSuccessMessageTitle').innerText = "Server Response - ";
            // document.getElementById('spnSuccessMessage').innerText = "New Password has been sent on your registered email";
            // let that = this;
            // $('#crmSuccessAlert').slideDown().slideUp(3000, function () {
            //   AppUtils.HandlePageClick(that.props.componentprops, 'login');
            // })
            this.setState({
                isModalOpen: true,
                forgetPassword:false
            })
        }
        else {
            document.getElementById('spnWarningMessageTitle').innerText = "Login Response - ";
            document.getElementById('spnWarningMessage').innerText = this.props.PnkStore.GetData('error').prettyMessage;
           // let that = this;
            $('#crmWarningAlert').slideDown().slideUp(3000, function () {
            })

            this.setState({ forgetpassword: false });
        }
        


    }



    render() {

        return (
            <div>
                {localStorage.getItem('current_user_name') == null && localStorage.getItem('current_user_login_token') == null && localStorage.getItem('current_user_profile') == null ?
                    <div>
                        <ForgotPage {...this.props} txtUserForgetEmail={this.state.txtUserForgetEmail}
                            txtForgotPasswordValidationMessage={this.state.txtForgotPasswordValidationMessage}
                            HandleForgotPasswordInputs={this.HandleForgotPasswordInputs}
                            ForgotPassword={this.ForgotPassword}
                            CheckForget={this.CheckForget}

                            HandleRouting={this.HandleRouting} />
                        <ResetModal {...this.props} isModalOpen={this.state.isModalOpen}
                            HandleRouting={this.HandleRouting}
                            HideResetModal={this.HideResetModal}
                            txtUserForgetEmail={this.state.txtUserForgetEmail}
                            ResetPassword={this.ResetPassword}
                            ForgotPassword={this.ForgotPassword}
                        />
                    </div>
                    : AppUtils.HandlePageClick(this.props.componentprops, 'home')}
                {((this.state.forgetPassword === true) ? ForgotPassword(this.props.PnkStore, this.forgetpassworddata, this.HandleForgetPasswordDataSuccessResponse) : "")}
            </div>
        )
    }
}

export const ForgotPasswordContainer = PnkConnect(forgotPasswordContainer, '');
